import { render } from "./Chapters.vue?vue&type=template&id=62cb8349&scoped=true&ts=true"
import script from "./Chapters.vue?vue&type=script&lang=ts"
export * from "./Chapters.vue?vue&type=script&lang=ts"

import "./Chapters.vue?vue&type=style&index=0&id=62cb8349&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cb8349"]])

export default __exports__